import React, { Component } from "react";

export class CameraFeed extends Component {
  /**
   * Processes available devices and identifies one by the label
   * @memberof CameraFeed
   * @instance
   */
  processDevices(devices) {
    devices.forEach((device) => {
      // console.log(device.label);
    });
    this.setDevice(devices);
  }

  /**
   * Sets the active device and starts playing the feed
   * @memberof CameraFeed
   * @instance
   */
  async setDevice(device) {
    const { deviceId } = device;
    await navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: { deviceId },
      })
      .then((stream) => {
        this.videoPlayer.srcObject = stream;
        this.videoPlayer.play();
        this.props.onCamInit();
        setTimeout(() => {
          this.takePhoto();
        }, 4000);
      })
      .catch(function (err) {
        console.log(err);
        window.location.replace("/error");
      });
  }

  /**
   * On mount, grab the users connected devices and process them
   * @memberof CameraFeed
   * @instance
   * @override
   */
  async componentDidMount() {
    const cameras = await navigator.mediaDevices.enumerateDevices();
    this.processDevices(cameras);
  }

  /**
   * Handles taking a still image from the video feed on the camera
   * @memberof CameraFeed
   * @instance
   */
  takePhoto = () => {
    const { sendFile } = this.props;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.id = "canvas";
    canvas.width = 680;
    canvas.height = 360;
    context.drawImage(this.videoPlayer, 0, 0, 680, 380);
    canvas.toBlob(sendFile);
  };

  render() {
    return (
      <div className="c-camera-feed">
        <div className="c-camera-feed__viewer">
          <video
            ref={(ref) => (this.videoPlayer = ref)}
            className="video-frame"
          />
        </div>
      </div>
    );
  }
}
